import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const setCSOSNCollection = async (context, search = '') => {
  const body = { active: true, search };
  const { data } = await api().post('fiscal.get-csosn', body);
  const collection = data.map((e) => ({ ...e, text: e.descricao, value: e }));
  context.commit(types.SET_CSOSN_COLLECTION, collection);
};
